import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  role: number[] | null;
  accessToken: string | null;
  userId: number | null;
  roleName: string | null;
  userDetail: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  role: null,
  accessToken: localStorage.getItem('accessToken') || null,
  userId: localStorage.getItem('userId') ? parseInt(localStorage.getItem('userId')!) : null,
  roleName: localStorage.getItem('roleName') || null,
  userDetail: localStorage.getItem('userDetail') ? JSON.parse(localStorage.getItem('userDetail')!) : null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<{ 
      role: [] | number; 
      accessToken: string; 
      userId?: number;
      roleName?: string;
      userDetail?: any;
      userData?: any;
    }>) {
      state.role = Array.isArray(action.payload.role) ? action.payload.role : [action.payload.role];
      state.accessToken = action.payload.accessToken;
      state.userId = action.payload.userId || null;
      state.roleName = action.payload.roleName || null;
      state.userDetail = action.payload.userDetail || null;
      state.loading = false;
      state.error = null;

      // Store in localStorage
      localStorage.setItem('accessToken', action.payload.accessToken);
      localStorage.setItem('role', JSON.stringify(state.role));
      if (action.payload.userId) localStorage.setItem('userId', action.payload.userId.toString());
      if (action.payload.roleName) localStorage.setItem('roleName', action.payload.roleName);
      if (action.payload.userDetail) localStorage.setItem('userDetail', JSON.stringify(action.payload.userDetail));
      if (action.payload.userData) localStorage.setItem('userData', JSON.stringify(action.payload.userData));
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.role = null;
      state.accessToken = null;
      state.userId = null;
      state.roleName = null;
      state.userDetail = null;
      state.loading = false;
      state.error = null;

      // Clear localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('role');
      localStorage.removeItem('userId');
      localStorage.removeItem('roleName');
      localStorage.removeItem('userDetail');
      localStorage.removeItem('userData');
      localStorage.removeItem('users');
      localStorage.removeItem('currentUserLocation');
      localStorage.removeItem('hasShownModalToday');
    },
    restoreAuthFromStorage(state) {
      const accessToken = localStorage.getItem('accessToken');
      const role = localStorage.getItem('role');
      const userId = localStorage.getItem('userId');
      const roleName = localStorage.getItem('roleName');
      const userDetail = localStorage.getItem('userDetail');
      // const userData = localStorage.getItem('userData');

      if (accessToken) {
        state.accessToken = accessToken;
        state.role = role ? JSON.parse(role) : null;
        state.userId = userId ? parseInt(userId) : null;
        state.roleName = roleName;
        state.userDetail = userDetail ? JSON.parse(userDetail) : null;
        // Note: userData will be restored to user slice separately
      }
    }
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, restoreAuthFromStorage } = authSlice.actions;
export default authSlice.reducer;